import {FbFormObject} from '../class/fb_form_object';

export class SeriesPoint extends FbFormObject {
    /**
     * override default columns
     */
    public setColumns() {
        this.column_definition = [
            {id: 'points', label: 'Points', visible: true, noclick: false, disable_ripple: true},
            {id: 'sc_username', label: 'Player', visible: true, noclick: false, disable_ripple: true}
        ];
    }

    /**
     * override default fields
     */
    public setEditFields() {
        this.edit_fields = [
            {
                caption: 'Points',
                class: 'card card-1 padding',
                field_class: '',
                fields: [
                    {
                        type: 'number',
                        name: 'points',
                        disabled: true
                    },
                    {
                        type: 'text',
                        name: 'sc_username',
                        disabled: true
                    }
                ]
            }
        ];
        super.setEditFields();
    }

    public loadStores(ext_obj?: any): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this.stores['series_points'] = this.storeService.createNoneGlobalStore('series_points',
                'race/series/' + String(this.custom_obj.series_id) + '/points', 'user_id');

            this.main_store = this.stores['series_points'];

            const selectFilter = [];
            selectFilter.push('first=0');
            selectFilter.push('no_limit=1');


            const stores = [];
            stores.push(this.stores['series_points'].loadStore(this.filter));

            Promise.all(stores).then((result) => {
                resolve(true);
            });
        });
    }

    public getDefaultModel() {
        return {
            data: {
            }
        };
    }

    /**
     * custom reload
     */
    public reload(): Promise<any> {
        return this.getStore().loadStore('');
    }

    /**
     * override select_boxes
     */
    public setSelectboxes() {
        // call super
        super.setSelectboxes();
    }
}
